import React from 'react';
import { Navigate } from 'react-router-dom';
import { isUserLoggedIn } from './authStorage'; // or wherever your logic is

const PrivateRoute = ({ children }) => {
  const isLoggedIn = isUserLoggedIn();

  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
